import { EVENTS } from './constants.js';

export function emitClickUrl(url) {
  window._oblikClickURL = url;
  document.dispatchEvent(new CustomEvent(EVENTS.clickUrl, { detail: { url } }));
}

export function emitShortUrl(url) {
  window._oblikShortURL = url;
  document.dispatchEvent(new CustomEvent(EVENTS.shortUrl, { detail: { url } }));
}

export function onClickUrl(handler) {
  document.addEventListener(EVENTS.clickUrl, handler);
}

export function onShortUrl(handler) {
  document.addEventListener(EVENTS.shortUrl, handler);
}
